module.exports = __webpack_public_path__ + "images/w-l-background-contact.38013119fd7d2b02498c919ce8f98bf5.svg";


//////////////////
// WEBPACK FOOTER
// ./img/w-l-background-contact.svg
// module id = 519
// module chunks = 0